import * as jf from 'joiful';
import { CaseImageType } from './case-image-type.enum';

export class CaseImageModel {
  @(jf.string().required().max(255))
  public imageId: string;
  @(jf.string().required().max(255))
  public imageUrl: string;
  public imageType?: CaseImageType;
}
